import React from "react";
import PropTypes from "prop-types";

import GradientOverflowContainer from "shared/components/GradientOverflowContainer";

import "./Question.scss";

const Question = ({ question, answer }) => (
	<GradientOverflowContainer className="profile-comment-question-widget">
		<h3 className="profile-comment-question-widget-question">{question}</h3>
		<p className="profile-comment-question-widget-answer">{answer}</p>
	</GradientOverflowContainer>
);

Question.propTypes = {
	question: PropTypes.string.isRequired,
	answer: PropTypes.string.isRequired,
};

export default Question;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileComment/Question.jsx